import statusService from 'services/status.service'

const state = {
    currentClaim: {},
    claims: [],
    loading: false
}

const getters = {
    
}

const mutations = {
    setClaims(state, claims = []) {
        state.claims = claims;
    },
    setCurrentClaim(state, claim = {}) {
        state.currentClaim = claim;
    },
    setLoadind(state, loading = false) {
        state.loading = loading;
    }
}

const actions = {
    getMyClaims ({ commit }, params) {
        commit('setLoadind', true);
        statusService.getMyClaims(params).then(response => {
            commit('setClaims', response);
            commit('setCurrentClaim', response[0]);
            commit('setLoadind', false);
        }).catch(() => {
            commit('setLoadind', false);
        })
    },
    selectCurrentClaim({ commit }, claim) {
        commit('setCurrentClaim', JSON.parse(JSON.stringify(claim)));
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
